import Vue from 'vue';
import Router from 'vue-router';
import AllQuizes from './views/All_Quizes.vue';
import AddQuiz from './views/Add_Quiz.vue';
import Login from './views/Login.vue';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: (to, from, next) => {
        if (!sessionStorage.getItem('userToken')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: '/',
      name: 'All Quizes',
      component: AllQuizes,
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('userToken')) {
          next();
        } else {
          next('/login');
        }
      }
    },
    {
      path: '/addQuiz',
      name: 'Add Quiz',
      component: AddQuiz,
      beforeEnter: (to, from, next) => {
        if (sessionStorage.getItem('userToken')) {
          next();
        } else {
          next('/login');
        }
      }
    }
  ]
});
